export const DEFAULT_ACTION = 'talentPlaylistsComponent.defaultAction'
export const DEFAULT_ACTION_VARIATION = 'talentPlaylistsComponent.defaultActionVariation'
export const RESET = 'talentPlaylistsComponent.reset'

export function defaultAction(payload: any) {
  return {
    type: DEFAULT_ACTION,
    payload
  } as const
}

export function defaultActionVariation(payload: any) {
  return {
    type: DEFAULT_ACTION_VARIATION,
    payload
  } as const
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export type TalentPlaylistsAction = ReturnType<typeof defaultAction | typeof defaultActionVariation | typeof reset>
